export default __webpack_public_path__ + "static/media/wind.57bae951.png";